import React, { ReactElement, useEffect } from 'react';
import { useLocation } from 'react-router';
import {
  Breadcrumbs, getTitle, homeBreadcrumb, setTitle,
} from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import PublikovanyTerminList from '../../module/PublikovanyTerminList';
import GlobalErrors from '../../module/GlobalErrors';
import PageHeadingWithBackButton from '../../module/PageHeadingWithBackButton';
import Layout from '../Layout';
import useFilterFromUrl from './hook/useFilterFromUrl';

const PublikovanyTerminListPage = (): ReactElement => {
  const { initialFilter, initialFilterLoading, initialFilterFinished } = useFilterFromUrl();
  const { pathname } = useLocation();

  useEffect(() => {
    setTitle(getTitle());
  }, []);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          to: pathname,
          heading: 'Tezaurus slovenského práva',
        },
      ]}
      />
      <GlobalErrors />
      <PageHeadingWithBackButton heading="Tezaurus slovenského práva" />
      <Loader loading={initialFilterLoading}>
        {initialFilter && !initialFilterLoading && initialFilterFinished && (
          <PublikovanyTerminList initialFilter={initialFilter} />)}
      </Loader>
    </Layout>
  );
};

export default PublikovanyTerminListPage;
